const {
  getRecaptchaSiteKey,
  shouldSkipRecaptcha,
  E2E_RECAPTCHA_TOKEN,
} = require("./signupConfig")

const SCRIPT_ID = "collar-recaptcha-v3"

function loadRecaptchaScript(siteKey = getRecaptchaSiteKey()) {
  if (typeof document === "undefined") {
    return Promise.reject(new Error("document is not available"))
  }
  if (shouldSkipRecaptcha()) {
    return Promise.resolve()
  }
  if (window.grecaptcha?.execute) {
    return Promise.resolve()
  }

  const existing = document.getElementById(SCRIPT_ID)
  if (existing) {
    return new Promise((resolve, reject) => {
      existing.addEventListener("load", () => resolve(), { once: true })
      existing.addEventListener(
        "error",
        () => reject(new Error("Failed to load reCAPTCHA")),
        { once: true }
      )
    })
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement("script")
    script.id = SCRIPT_ID
    script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error("Failed to load reCAPTCHA"))
    document.head.appendChild(script)
  })
}

function executeRecaptcha(action = "provider_interest") {
  if (shouldSkipRecaptcha()) {
    return Promise.resolve(E2E_RECAPTCHA_TOKEN)
  }
  if (typeof window === "undefined" || !window.grecaptcha?.execute) {
    return Promise.reject(new Error("reCAPTCHA is not ready"))
  }

  const siteKey = getRecaptchaSiteKey()
  return new Promise((resolve, reject) => {
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(siteKey, { action })
        .then((token) => {
          if (!token) reject(new Error("Empty reCAPTCHA token"))
          else resolve(token)
        })
        .catch(reject)
    })
  })
}

module.exports = {
  loadRecaptchaScript,
  executeRecaptcha,
}
